(function(){
  'use strict';

  function initWorkshopEnrolment(configuration) {
    const pageQueryStringArray = window.location.href.split('?');
    const courseDetailsLocal = JSON.parse( localStorage.getItem('courseDetails') );
    let modifiedPageUrl = '';
    let xhrDataRequest = new XMLHttpRequest(); // We use this to make our asynchronous requests for data
    let pageRedirectFlag = [];
    let courseId = [];
    let courseInstanceId = [];

    // Page hooks and event listeners
    let alertMessagePopupCloseButton = document.getElementsByClassName(configuration.alertMessageCloseButtonClass);
    let loadingMessage = document.getElementsByClassName(configuration.loadingMessageContainerClass);
    let stepTwoMessage = document.getElementsByClassName(configuration.stepTwoMessageContainerClass);
    let stepTwoButton = document.getElementsByClassName(configuration.returnStepTwoButtonClass);
    let stepTwoContinueButton = document.getElementsByClassName(configuration.stepTwoContinueButtonClass);
    let signOutLink = document.getElementsByClassName(configuration.signOutLinkClass);

    alertMessagePopupCloseButton = alertMessagePopupCloseButton[0];
    alertMessagePopupCloseButton.addEventListener('click', onAlertCloseClick);
    loadingMessage = loadingMessage[0];
    stepTwoMessage = stepTwoMessage[0];
    stepTwoButton = stepTwoButton[0];
    stepTwoButton.addEventListener('click', function() {
      // Return to Step #2
      displayStep(2);
    });
    stepTwoContinueButton = stepTwoContinueButton[0];
    stepTwoContinueButton.addEventListener('click', onStepTwoContinue);
    signOutLink = signOutLink[0];
    signOutLink.addEventListener('click', onSignOutClick);

    /**
     * Check if the user has been redirected to
     * this form from the payment gateway.
     * If so, skip straight to Step #4.
     */
    if (pageQueryStringArray.length > 1) {
      // eslint-disable-next-line no-undef
      pageRedirectFlag = squiz.fn.getQueryParameterValuesByKey(pageQueryStringArray[1], 'payment');

      if (pageRedirectFlag.length !== 0) {
        // Hide the loading message (this is visible by default on page load)
        toggleLoadingMessage(false);

        /**
         * Remove the query parameters from the page URL so
         * that the user doesn't accidentally re-submit the
         * payment status. This will prevent false-positive
         * error emails being sent if someone reloads the page.
         */
        history.pushState({}, '', pageQueryStringArray[0]);

        // Skip to step #4
        displayStep(4);
        return;
      }
    }

    // Clear the invoice data stored in the browser storage
    localStorage.removeItem('userInvoiceId');

    /**
     * Prerequisites.
     * If these checks fail then we are missing critical
     * information needed to continue.
     * Check the page URL and local storage for the
     * required parameters. The Course ID, Instance ID
     * and course details are needed for enrolment.
     */
    if (pageQueryStringArray.length > 1) {
      // Attempt to extract the IDs from the page URL
      // eslint-disable-next-line no-undef
      courseId = squiz.fn.getQueryParameterValuesByKey(pageQueryStringArray[1], 'ID');
      // eslint-disable-next-line no-undef
      courseInstanceId = squiz.fn.getQueryParameterValuesByKey(pageQueryStringArray[1], 'instanceId');
    }

    if (courseId.length !== 0 && courseInstanceId.length !== 0) {
      // Check if the IDs are empty
      if (courseId[0] === '' || courseInstanceId[0] === '') {
        // ERROR. Missing one or more required IDs so we cannot proceed.
        setAlertMessage('One or more IDs are missing from the page URL. Please return to the previous page and try to enrol again.', '', true);
        return;
      }
    } else {
      // No query string values, so check local storage instead

      if (courseDetailsLocal !== null) {
        // Check if the IDs are in local storage
        if (courseDetailsLocal.courseId !== '' && courseDetailsLocal.courseId !== undefined && courseDetailsLocal.courseInstanceId !== '' && courseDetailsLocal.courseInstanceId !== undefined) {
          // Values exist in the local storage

          // Update the local variables and continue to make the API request below
          courseId = [courseDetailsLocal.courseId];
          courseInstanceId = [courseDetailsLocal.courseInstanceId];
        } else {
          // Storage object exists, but is missing values

          // ERROR. Missing one or more required IDs so we cannot proceed.
          setAlertMessage('One or more IDs are missing from the page URL. Please return to the previous page and try to enrol again.', '', true);
          return;
        }
      } else {
        // ERROR. Missing one or more required IDs so we cannot proceed.
        setAlertMessage('One or more IDs are missing from the page URL. Please return to the previous page and try to enrol again.', '', true);
        return;
      }
    }

    // Show the loading message
    toggleLoadingMessage(true);

    // Retrieve the additional course instance details
    getAxcelerateCourseDetails(courseInstanceId[0])
      .then( (data) => {
        // Hide the loading message
        toggleLoadingMessage(false);

        if (data.length === 0) {
          // No details were returned from aXcelerate API
          setAlertMessage(`We were unable to find any details for the course instance: ${courseInstanceId[0]}. Please return to the previous page and try to enrol again.`, '', true);
        } else {
          // Clear any currently saved values
          localStorage.removeItem('courseDetails');

          // Store the IDs and instance details in local storage
          localStorage.setItem('courseDetails',
            JSON.stringify({
              "courseId": courseId[0],
              "courseInstanceId": courseInstanceId[0],
              "courseName": data[0].NAME,
              "courseDate": data[0].DATEDESCRIPTOR,
              "courseLocation": data[0].LOCATION,
               "courseCost": data[0].COST
            })
          );

          // Intialise the first step of the form
          initStepOne();
        }
      })
      .catch( (errorObject) => {
        if (errorObject.eventType === 'error') {
          setAlertMessage('We were unable to contact aXcelerate for the course details. Please return to the previous page and try to enrol again.', `Status code: ${errorObject.response.status}`, true);
        }

        // Hide the loading message
        toggleLoadingMessage(false);
      });

    // END. Enrolment form initialisation.

    /**
     * Run the required login checks for Step #1 and add
     * the necessary listeners to hijack the form submissions
     *
     * @returns void
     */
    function initStepOne() {
      const stepOneAjaxFormConfig = {
        formElement: document.getElementsByClassName('js-ajax-contact-form')[0],
        validationFunctionAsync: (formElement) => { return validateStepOneForm(formElement); },
        onLoadCallback: (xhrEvent) => { onStepOneSubmissionComplete(xhrEvent); }
      };
      const userContactIdLocal = localStorage.getItem('userContactId');

      // Initialise the AJAX loader for the form on Step #1
      // eslint-disable-next-line no-undef
      squiz.fn.initFormSubmissionHandler(stepOneAjaxFormConfig);

      // Check if the user already has an aXcelerate Contact ID in the local storage
      if (userContactIdLocal !== null) {
        /**
         * The user already has an active session.
         * Attempt to enrol the user and then proceed to step #2.
         */
         tentativelyEnrolUser();
      } else {
        /**
         * This is a new user session as there is no contact ID
         * stored in the browser local storage.
         *
         * One of two things is happening here:
         * 1. Either this is a new user visiting the page
         *    for the first time (or a new session); OR,
         * 2. This is a user that has completed the aXcelerate
         *    login and has just been redirected back to this form
         *
         * For #1, no action needs to be taken here.
         *
         * For #2, there will be a "access_code" query parameter
         * and Matrix will automatically print a hidden Custom Form
         * into the page that we need to submit with JavaScript.
         * See Matrix Asset: #22428
         *
         * It's setup this way because we need to process the response
         * from the form's Submission Action in Matrix so that we can
         * encrypt the user's contact ID before storing it in the browser.
         */

        // Check for the hidden Matrix Form.
        const accessCodeForm = document.getElementsByClassName(configuration.accessCodeFormContainerClass);

        if (accessCodeForm.length !== 0) {
          // Initialise the AJAX loader for the access code form
          const accessCodeAjaxFormConfig = {
            formElement: accessCodeForm[0],
            onLoadCallback: (xhrEvent) => { onAccessCodeSubmissionComplete(xhrEvent); }
          };

          // Update the page URL to remove the "access_code" query parameter
          if (pageQueryStringArray.length > 0) {
            // eslint-disable-next-line no-undef
            modifiedPageUrl = squiz.fn.removeQueryParameterValuesByKey(pageQueryStringArray[1], 'access_code');
            window.history.replaceState(null, document.title, pageQueryStringArray[0] + '?' + modifiedPageUrl);
          }

          // eslint-disable-next-line no-undef
          squiz.fn.initFormSubmissionHandler(accessCodeAjaxFormConfig);

          // Automatically submit the access code form
          accessCodeForm[0].querySelector('input[type=submit]').click();
        }
      }
    }

    /**
     * Additional client-side validation for the form on Step #1
     *
     * @param {HTML Element} formElement The Step #1 form
     *
     * @returns Boolean
     */
    function validateStepOneForm(formElement) {
      const emailValue = encodeURIComponent(formElement.querySelector('input[type="email"]').value);

      return new Promise( (resolve, reject) => {

        if (emailValue === '') {
          // Just let the form submit for server-side validation if no email has been provided
          resolve(true);

          // No need to complete the lookup below
          return;
        }

        if (emailValue.indexOf('%20') !== -1) {
          setAlertMessage('Please use an email address without spaces.');
          reject(false);

          // No need to complete the lookup below
          return;
        }

        // Check if the provided email is already associated with an account
        getAxcelerateContactList(emailValue)
          .then( (data) => {
            // Check the response data
            if (data.ERROR) {
              // An error occurred with the provided email address
              setAlertMessage('Please provide a valid email address.');
              reject(false);
            } else if (data.UNIQUE) {
              // There are no existing entries in the contact list
              resolve(true);
            } else {
              // At least one other contact was found that uses this email
              setAlertMessage('That email address is already in use by an aXcelerate account.', 'Please use the "Continue with aXcelerate" button, or try a different email address.');
              reject(false);
            }
          })
          .catch( (errorObject) => {
            if (errorObject.eventType === 'error') {
              setAlertMessage('There has been a problem checking the aXcelerate contact list. Please try again, or continue using a login.', `Status code: ${errorObject.response.status}`);
            }

            reject(false);
          });
      });
    }

    /**
     * Actions to take once the new contact form has been submitted
     *
     * @param {XHR Event} xhrEvent The loadend event of the XHR request that submitted the form
     *
     * @returns void
     */
    function onStepOneSubmissionComplete(xhrEvent) {
      let responseContent = null;

      try {
        // Matrix may give us JSON or HTML
        responseContent = JSON.parse(xhrEvent.currentTarget.response);

        // Hide the JSON reponse that has been inserted into the page
        document
          .getElementsByClassName(configuration.createUserFormContainerClass)[0]
          .getElementsByClassName('js-ajax-form-response-wrapper')[0]
          .style.display = 'none';
      } catch {
        // Do nothing. Likely this is just the form being returned with validation errors
        return;
      }

      if (!responseContent.ERROR) {
        // Store the encrypted contact ID in local storage
        localStorage.setItem('userContactId', responseContent.CONTACTID);

        /**
         * Set the expiry time (2 hours) for the user's contact ID.
         * This is used for the login button component (module: workshop-sign-in)
         */
        localStorage.setItem('userContactExpiry', Date.now() + 7200000);

        /**
         * Track that this is new user that won't necessarily
         * have an aXcelerate account.
         */
        localStorage.setItem('userStatus', 'new');

        // Capture the user's details into local storage
        // The keys used here should match the input IDs on the General Details form (Asset ID: 22329).
        localStorage.setItem('userDetails',
          JSON.stringify({
            "q22332_q1": responseContent.GIVENNAME, // First name
            "q22332_q2": responseContent.SURNAME, // Last name
            "q22332_q5": responseContent.EMAILADDRESS, // Email
            "q22332_q3": "", // Unique Student Identifier (USI)
            "q22332_q8": "", // Date of birth
            "q22332_q7": "", // Organisation
            "q22332_q6": "" // Phone number
          })
        );

        // Attempt to enrol the user and then proceed to step #2
        tentativelyEnrolUser();
      }
    }

    /**
     * Actions to take once the new login Access Code form has been submitted
     *
     * @param {XHR Event} xhrEvent The loadend event of the XHR request that submitted the form
     *
     * @returns void
     */
    function onAccessCodeSubmissionComplete(xhrEvent) {
      let responseContent = null;

      try {
        // Matrix may give us JSON or HTML
        responseContent = JSON.parse(xhrEvent.currentTarget.response);
      } catch {
        // Do nothing. Likely this is just the form being returned with validation errors
        return;
      }

      if (!responseContent.ERROR) {
          // User verified successfully.

          // Store the encrypted contact ID in local storage
          localStorage.setItem('userContactId', responseContent.CONTACTID);

          /**
           * Set the expiry time (2 hours) for the user's contact ID.
           * This is used for the login button component (module: workshop-sign-in)
           */
          localStorage.setItem('userContactExpiry', Date.now() + 7200000);

          // Attempt to enrol the user and then proceed to step #2.
          tentativelyEnrolUser();
      } else {
        // Verification was unsuccessful. Show error message
        setAlertMessage('There has been an error verifying your aXcelerate account. Please try again or continue with a different email address.', `Message: ${responseContent.DETAILS}`);
      }
    }

    /**
     * Actions to take once the new general details form has been submitted.
     *
     * @param {XHR Event} xhrEvent The loadend event of the XHR request that submitted the form
     *
     * @returns void
     */
    function onStepTwoSubmissionComplete(xhrEvent) {
      const customErrorMessagesArray = [];
      let responseContent = null;

      try {
        // Matrix may give us JSON or HTML
        responseContent = JSON.parse(xhrEvent.currentTarget.response);

        // Hide the JSON reponse that has been inserted into the page
        document
          .getElementsByClassName(configuration.detailsFormContainerClass)[0]
          .getElementsByClassName('js-ajax-form-response-wrapper')[0]
          .style.display = 'none';
      } catch {
        // Likely this is just the form being returned with validation errors
        // Add the address picker
        initAddressLookup(enrolmentConfiguration);
        return;
      }

      if (responseContent.ERROR) {
        // Error occurred, show a message

        // Set a custom message for DOB errors
        if (responseContent.DETAILS.indexOf('DOB') !== -1) {
          customErrorMessagesArray.push('Your date of birth cannot be in the future.');
        }

        // Set a custom message for USI errors
        if (responseContent.DETAILS.indexOf('USI') !== -1) {
          customErrorMessagesArray.push('Universal Student Identifier (USI) is not valid. Please check your USI.');
        }

        // Capture any other error messages
        if (customErrorMessagesArray.length === 0) {
          customErrorMessagesArray.push(responseContent.DETAILS);
        }

        setAlertMessage('We were unable to update your details.', `${responseContent.MESSAGES} ${customErrorMessagesArray.join(' \n')}`);

        // Reset the form in Step #2
         initStepTwo();
      } else {
        /**
         * Form submission successful. Store the updated user details
         * in local storage.
         * The keys used here should match the input IDs on the
         * General Details form (Asset ID: 22329).
         */
        localStorage.setItem('userDetails',
          JSON.stringify({
            "q22332_q1": responseContent.GIVENNAME, // First name
            "q22332_q2": responseContent.SURNAME, // Last name
            "q22332_q5": responseContent.EMAILADDRESS, // Email
            "q22332_q3": responseContent.USI, // Unique Student Identifier (USI)
            "q22332_q8": responseContent.DOB, // Date of birth
            "q22332_q7": responseContent.ORGANISATION, // Organisation
            "q22332_q6": responseContent.MOBILEPHONE, // Phone number
            "q22330_q2": `${responseContent.ADDRESS1}${ (responseContent.ADDRESS2 !== null) ? ` ${responseContent.ADDRESS2}` : '' }`, // Address #1 and Address #2
            "q22330_q4": responseContent.CITY, // City
            "q22330_q5": responseContent.STATE, // State
            "q22330_q6": responseContent.POSTCODE // Postcode
          })
        );

        // Submission success, proceed to Step #3
        displayStep(3);
      }
    }

    /**
     * Actions to take when the user wants to progress to Step #3.
     *
     * Validate known details and alert user if data missing.
     * Otherwise, contnue to Step #3.
     *
     * @param {Click Event} evt Click Event on the button
     *
     * @returns void
     */
    function onStepTwoContinue(evt) {
      const userDetailsLocal = JSON.parse( localStorage.getItem('userDetails') );
      const failedFieldsArray = [];

      evt.preventDefault();

      if (userDetailsLocal === null) {
        setAlertMessage('One or more of your details are missing.', 'To update your details, login to aXcelerate, update your profile and then return to this page.');
        return;
      }

      /**
       * These data are required to proceed:
       * - Given Name
       * - Family Name
       * - Unique Student Identifier (USI)
       * - Date Of Birth
       * - Email
       */
      if ( valueIsFalsy(userDetailsLocal.q22332_q1) ) {
        failedFieldsArray.push('Given Name');
      }

      if ( valueIsFalsy(userDetailsLocal.q22332_q2) ) {
        failedFieldsArray.push('Family Name');
      }

      if ( valueIsFalsy(userDetailsLocal.q22332_q3) ) {
        failedFieldsArray.push('Unique Student Identifier');
      }

      if ( valueIsFalsy(userDetailsLocal.q22332_q5) ) {
        failedFieldsArray.push('Email');
      }

      if ( valueIsFalsy(userDetailsLocal.q22332_q8) ) {
        failedFieldsArray.push('Date Of Birth');
      }

      if (failedFieldsArray.length > 0) {
        // One or more fields failed validation
        setAlertMessage(`The following details are missing: ${failedFieldsArray.join(', ')}.`, 'To update your details, login to aXcelerate, update your profile and then return to this page.');
        return;
      }

      // If all checks pass, proceed to Step #3.
      displayStep(3);
    }

    /**
     * Load the general details form into step #2, then add
     * the necessary listeners and insert the user details
     *
     * @returns void
     */
    function initStepTwo() {
      const userStatusLocal = localStorage.getItem('userStatus');
      const detailsForm = document.getElementsByClassName(enrolmentConfiguration.detailsFormContainerClass)[0];

      // Show the loading message
      toggleLoadingMessage(true);

      // Retrieve the general details form
      getGeneralDetailsForm()
        .then( (data) => {
          // Add the form to the page
          detailsForm.innerHTML = data;

          // Generate the config for the AJAX loader for the form on Step #2
          const stepTwoAjaxFormConfig = {
              formElement: document.getElementsByClassName('js-ajax-details-form')[0],
              onLoadCallback: (xhrEvent) => { onStepTwoSubmissionComplete(xhrEvent); }
          };

          // Hide the loading message
          toggleLoadingMessage(false);

          // Update the form with the user's details
          populateGeneralDetails();

          /**
           * If this is a user with an aXcelerate account, prevent
           * them from updating or submitting the form.
           */
          if (userStatusLocal !== 'new') {
            const allFormInputs = detailsForm.querySelectorAll('input');
            const formSubmitInput = detailsForm.querySelector('input[type=submit]');

            for (let item of allFormInputs) {
              item.setAttribute('disabled', '');
            }

            // Remove the submit button
            formSubmitInput.remove();

            // Show the update message
            stepTwoMessage.classList.remove('is-hidden');

            // Show the continue button
            stepTwoContinueButton.classList.remove('is-hidden');
          } else {
            // For new users, add the form submission handlers
            // eslint-disable-next-line no-undef
            squiz.fn.initFormSubmissionHandler(stepTwoAjaxFormConfig);

            // Add the address picker
            initAddressLookup(enrolmentConfiguration);
          }
        })
        .catch( (errorObject) => {
          if (errorObject.eventType === 'error') {
            setAlertMessage('There has been a problem retrieving the general details form. Please try again later.', `Status code: ${errorObject.response.status}`, true);
          }

          // Hide the loading message
          toggleLoadingMessage(false);
        });
    }

    /**
     * Retrieve the user's details from local storage (as set in Step #1)
     * as well as from the aXcelerate API and then insert the known details
     * into the form
     *
     * @returns void
     */
    function populateGeneralDetails() {
      const userContactIdLocal = localStorage.getItem('userContactId');
      const userDetailsLocal = JSON.parse( localStorage.getItem('userDetails') ) || {};

      // Show the loading message
      toggleLoadingMessage(true);

      // Insert the contact ID into the corresponding hidden form field.
      document.getElementById('q22330_q1').value = userContactIdLocal;

      // Retrieve any additional information about this user
      getAxcelerateUserDetails(userContactIdLocal)
        .then( (data) => {
          // Check the response data
          if (data.ERROR) {
            // No action here as we are just retrieving extra info
          } else {
            // Add/replace any known additional details in the local storage
            // The IDs used here should match the input IDs on the General Details form (Asset ID: 22329).
            for (const prop in data) {
              // Only update fields we received data for
              if (data[prop] !== null) {
                // Replace any existing local data
                switch (prop) {
                  case 'GIVENNAME':
                    userDetailsLocal.q22332_q1 = data[prop];
                    break;

                  case 'SURNAME':
                    userDetailsLocal.q22332_q2 = data[prop];
                    break;

                  case 'USI':
                    userDetailsLocal.q22332_q3 = data[prop];
                    break;

                  case 'DOB':
                      userDetailsLocal.q22332_q8 = data[prop];
                    break;

                  case 'EMAILADDRESS':
                    userDetailsLocal.q22332_q5 = data[prop];
                    break;

                  case 'MOBILEPHONE':
                    userDetailsLocal.q22332_q6 = data[prop];
                    break;

                  case 'ORGANISATION':
                    userDetailsLocal.q22332_q7 = data[prop];
                    break;

                  case 'ADDRESS1':
                     userDetailsLocal.q22330_q2 = data[prop];
                    break;

                  case 'ADDRESS2':
                    // Append to Address 1
                     userDetailsLocal.q22330_q2 += ` ${data[prop]}`;
                    break;

                  case 'CITY':
                     userDetailsLocal.q22330_q4 = data[prop];
                    break;

                  case 'STATE':
                     userDetailsLocal.q22330_q5 = data[prop];
                    break;

                  case 'POSTCODE':
                     userDetailsLocal.q22330_q6 = data[prop];
                    break;

                  default:
                    break;
                }
              }
            }
          }

          // Insert the updated user details that are saved in local storage
          for (const prop in userDetailsLocal) {
            document.getElementById(prop).value = userDetailsLocal[prop];
          }

          // Populate the address field
          document.getElementById('q22332_q9').value = generateFriendlyAddress(userDetailsLocal);

          // Update the stored user details
          localStorage.setItem('userDetails', JSON.stringify(userDetailsLocal) );

          // Hide the loading message
          toggleLoadingMessage(false);
        })
        .catch( () => {
          // Notify the user that if were unable to retrieve their details
          setAlertMessage('We were unable to retrieve your user details, please enter them into the form.');

          // Insert the user details that may be currently saved in local storage
          for (const prop in userDetailsLocal) {
            document.getElementById(prop).value = userDetailsLocal[prop];
          }

          // Hide the loading message
          toggleLoadingMessage(false);
        });
    }

    /**
     * Attempt to enrol the user in the course.
     *
     * @returns void
     */
    function tentativelyEnrolUser() {
      const userContactIdLocal = localStorage.getItem('userContactId');
      const courseDetailsLocal = JSON.parse( localStorage.getItem('courseDetails') );

      // Show the loading message
      toggleLoadingMessage(true);

      getAxcelerateTentativeCourseEnrolment(courseDetailsLocal.courseInstanceId, userContactIdLocal)
        .then( (data) => {
          // Hide the loading message
          toggleLoadingMessage(false);

          if (data.ERROR) {
              // Catch if the user is already enrolled in the course
             if (data.DETAILS.indexOf('already enrolled') !== -1) {
              // User already enrolled
              setAlertMessage('Our records show that you are already enrolled in this course.', 'Please logout and enrol as a different user.');

              // Proceed to Step #2
              displayStep(2);
             } else {
              // Breaking error occurred
              setAlertMessage('We were unable to enrol you in this course. Please return to the previous page and try to enrol again.', `${data.MESSAGES} ${data.DETAILS}`, true);
             }
          } else {
            // Save the invoice ID for later use
            localStorage.setItem('userInvoiceId', data.INVOICEID);

            // User tentatively enrolled, proceed to Step #2
            displayStep(2);
          }
        })
        .catch( (errorObject) => {
          if (errorObject.eventType === 'error') {
            setAlertMessage('We were unable to enrol you in this course. Please return to the previous page and try to enrol again.', `Status code: ${errorObject.response.status}`, true);
          }

          // Hide the loading message
          toggleLoadingMessage(false);
        });
    }

    /**
     * Insert the user's details step #3 for review.
     * Also insert the necessary details into the
     * hidden payment form.
     *
     * @returns void
     */
    function initStepThree() {
      const userContactIdLocal = localStorage.getItem('userContactId');
      const userDetailsLocal = JSON.parse( localStorage.getItem('userDetails') );
      const courseDetailsLocal = JSON.parse( localStorage.getItem('courseDetails') );
      const userInvoiceLocal = localStorage.getItem('userInvoiceId');
      const courseNameContainers = document.getElementsByClassName(configuration.courseNameContainerClass);

      // Insert the user and course info into the page for user review
      for (let i = 0, j = courseNameContainers.length; i < j; ++i) {
        courseNameContainers[i].textContent = courseDetailsLocal.courseName;
      }

      document.getElementsByClassName(configuration.studentNameContainerClass)[0].textContent = `${userDetailsLocal.q22332_q1} ${userDetailsLocal.q22332_q2}`;
      document.getElementsByClassName(configuration.studentAddressContainerClass)[0].textContent = generateFriendlyAddress(userDetailsLocal);
      document.getElementsByClassName(configuration.courseDateContainerClass)[0].textContent = courseDetailsLocal.courseDate;
      document.getElementsByClassName(configuration.courseLocationContainerClass)[0].textContent = courseDetailsLocal.courseLocation;
      document.getElementsByClassName(configuration.courseCostContainerClass)[0].textContent = `$${courseDetailsLocal.courseCost}`;

      // Insert the user and course details into the hidden payment form
      document.querySelector('input[name=bill_to_forename]').value = userDetailsLocal.q22332_q1;
      document.querySelector('input[name=bill_to_surname]').value = userDetailsLocal.q22332_q2;
      document.querySelector('input[name=bill_to_email]').value = userDetailsLocal.q22332_q5;
      document.querySelector('input[name=contactId]').value = userContactIdLocal;
      document.querySelector('input[name=instanceId]').value = courseDetailsLocal.courseInstanceId;
      document.querySelector('input[name=invoiceId]').value = userInvoiceLocal;
      document.querySelector('input[name=amount]').value = courseDetailsLocal.courseCost;
    }

    /**
     * Parse the response from the payment gateway to
     * provide feedback to the user.
     *
     * The Constant "paymentResponse" should be printed
     * by Matrix into the page content when the payment
     * gateway makes a POST back to the enrolment form page.
     *
     * CyberSource Reason Codes:
     * https://developer.cybersource.com/library/documentation/dev_guides/Secure_Acceptance_Hosted_Checkout/html/index.html#t=Topics%2FReason_Codes.htm&rhsearch=codes&rhhlterm=codes&rhsyns=%20
     *
     * @returns void
     */
    function initStepFour() {
      const userContactIdLocal = localStorage.getItem('userContactId');
      const userDetailsLocal = JSON.parse( localStorage.getItem('userDetails') );
      const courseDetailsLocal = JSON.parse( localStorage.getItem('courseDetails') );
      const userInvoiceLocal = localStorage.getItem('userInvoiceId');
      const paymentResponseContainer = document.getElementsByClassName(configuration.paymentResponseContainerClass)[0];
      // eslint-disable-next-line no-undef
      const paymentGatewayResponse = (typeof paymentResponse !== 'undefined') ? JSON.parse( paymentResponse ) : null;

      // Check if the payment gateway response has been added to the page
      if (paymentGatewayResponse !== null) {
        // Check the reason code
        if (paymentGatewayResponse.reason_code === '100') {
          // Payment success

          // Show the loading message
          toggleLoadingMessage(true);

          // Apply the user's payment to their course enrolment
          getAxcelerateApplyCoursePayment(courseDetailsLocal.courseCost, userInvoiceLocal, userContactIdLocal)
            .then( (data) => {

              if (!data.ERROR) {
                // The user's payment has been applied to their enrolment
                // Confirm user's enrolment in the course
                getAxcelerateConfirmCourseEnrolment(courseDetailsLocal.courseInstanceId, userInvoiceLocal, userContactIdLocal)
                  .then( (data) => {
                    // Hide the loading message
                    toggleLoadingMessage(false);

                    if (!data.CODE) {
                      // Payment and enrolment success! Insert user feedback into the page
                       paymentResponseContainer.innerHTML = `<p>Thank you for your payment, ${userDetailsLocal.q22332_q1}.<br>Your payment reference number is: ${paymentGatewayResponse.req_reference_number}</p>`;
                    } else {
                      // An error occurred. Show message
                      setAlertMessage('Your payment was processed, but there has been a problem confirming your enrolment in this course. Endeavour Energy has been notified and will be in contact with you. If you need to contact us we can be reached at technical.training@endeavourenergy.com.au', '', true);

                      // Trigger the error form submission
                      submitErrorForm(`Payment was processed and applied to account, but unable to confirm user's enrolment in the course. API message: ${data.MESSAGES}. ANZ payment reference number: ${paymentGatewayResponse.req_reference_number}`);
                    }
                  })
                  .catch( (errorObject) => {
                    if (errorObject.eventType === 'error') {
                      setAlertMessage('Your payment was processed, but there has been a problem confirming your enrolment in this course. Endeavour Energy has been notified and will be in contact with you. If you need to contact us we can be reached at technical.training@endeavourenergy.com.au', `Status code: ${errorObject.response.status}`, true);

                      // Trigger the error form submission
                      submitErrorForm(`Payment was processed and applied to account, but unable to confirm user's enrolment in the course. Status code: ${errorObject.response.status}. ANZ payment reference number: ${paymentGatewayResponse.req_reference_number}`);
                    }

                    // Hide the loading message
                    toggleLoadingMessage(false);
                  });
              } else {
                // An error occurred. Show message
                setAlertMessage('Your payment was processed, but there has been a problem completing your enrolment in this course. Endeavour Energy has been notified and will be in contact with you. If you need to contact us we can be reached at technical.training@endeavourenergy.com.au', `Error: ${data.MESSAGES}`, true);

                // Hide the loading message
                toggleLoadingMessage(false);

                // Trigger the error form submission
                submitErrorForm(`Payment success, but unable to apply the payment to the invoice. API message: ${data.MESSAGES}. ANZ payment reference number: ${paymentGatewayResponse.req_reference_number}`);
              }
            })
            .catch( (errorObject) => {
              if (errorObject.eventType === 'error') {
                setAlertMessage('Your payment was processed, but there has been a problem completing your enrolment in this course. Endeavour Energy has been notified and will be in contact with you. If you need to contact us we can be reached at technical.training@endeavourenergy.com.au', `Status code: ${errorObject.response.status}`, true);

                // Trigger the error form submission
                submitErrorForm(`Payment success, but unable to apply the payment to the invoice. Status code: ${errorObject.response.status}. ANZ payment reference number: ${paymentGatewayResponse.req_reference_number}`);
              }

              // Hide the loading message
              toggleLoadingMessage(false);

            });
        } else if (paymentGatewayResponse.decision === 'CANCEL') {
          // User cancelled the payment
          // Show a message
          setAlertMessage('You have cancelled payment for this course. You may still review your details and try again');

          // Return to Step #3
          displayStep(3);
        } else {
          // An error has occurred. Show message
          setAlertMessage('There has been a problem verifying your payment for the course. Endeavour Energy has been notified and will be in contact with you.', 'If you need to contact us we can be reached at technical.training@endeavourenergy.com.au', true);

          // Trigger the error form submission
          submitErrorForm(`Payment gateway response code: ${paymentGatewayResponse.reason_code}. Payment gateway message: ${paymentGatewayResponse.message}`);
        }
      } else {
        // No info was returned or inserted into the page, show message
        setAlertMessage('There has been a problem verifying your payment for the course. Endeavour Energy has been notified and will be in contact with you.', 'If you need to contact us we can be reached at technical.training@endeavourenergy.com.au', true);

        // Trigger the error form submission
        submitErrorForm('Bad or missing response from payment gateway. Payment may not have been completed.');
      }
    }

    /**
     * Contact Matrix to determine if the provided email address
     * is already associated with an aXcelerate user account
     *
     * @param {String} emailAddress The email address to lookup
     *
     * @returns Promise
     */
    function getAxcelerateContactList(emailAddress) {
      let url = "";
      let requestPromise = null;

      // Abort any current request
      xhrDataRequest.abort();

      // Generate a new request (this clears any current listeners)
      xhrDataRequest = new XMLHttpRequest();

      // Create our new Promise
      requestPromise = newRequestPromise(xhrDataRequest);

      // Assemble the request URL
      url = `${enrolmentConfiguration.axcelerateContactListEndpoint}?emailAddress=${emailAddress}&cors_key=${enrolmentConfiguration.corsKey}`;

      // Set up our request
      xhrDataRequest.open("GET", url);

      // Make the request
      xhrDataRequest.send();

      return requestPromise;
    }

    /**
     * Retrieve the General Details form from Matrix
     *
     * @returns Promise
     */
    function getGeneralDetailsForm() {
      let url = "";
      let requestPromise = null;

      // Abort any current request
      xhrDataRequest.abort();

      // Generate a new request (this clears any current listeners)
      xhrDataRequest = new XMLHttpRequest();

      // Create our new Promise
      requestPromise = newRequestPromise(xhrDataRequest, 'html');

      // Assemble the request URL
      url = `${enrolmentConfiguration.axcelerateUpdateUserDetailsForm}?cors_key=${enrolmentConfiguration.corsKey}`;

      // Set up our request
      xhrDataRequest.open("GET", url);

      // Make the request
      xhrDataRequest.send();

      return requestPromise;
    }

    /**
     * Contact Matrix to retrieve any additional details for
     * the provided aXcelerate user ID
     *
     * @param {String} contactId The encrypted ID of the user to lookup
     *
     * @returns Promise
     */
    function getAxcelerateUserDetails(contactId) {
      let url = "";
      let requestPromise = null;

      // Abort any current request
      xhrDataRequest.abort();

      // Generate a new request (this clears any current listeners)
      xhrDataRequest = new XMLHttpRequest();

      // Create our new Promise
      requestPromise = newRequestPromise(xhrDataRequest);

      // Assemble the request URL
      url = `${enrolmentConfiguration.axcelerateUserDetailsLookupEndpoint}?contactid=${contactId}&cors_key=${enrolmentConfiguration.corsKey}`;

      // Set up our request
      xhrDataRequest.open("GET", url);

      // Make the request
      xhrDataRequest.send();

      return requestPromise;
    }

    /**
     * Contact Matrix to retrieve the details for a specific
     * instance of a course. e.g. name, dates, cost
     *
     * @param {String} instanceId The ID of the course instance to lookup
     *
     * @returns Promise
     */
    function getAxcelerateCourseDetails(instanceId) {
      let url = "";
      let requestPromise = null;

      // Abort any current request
      xhrDataRequest.abort();

      // Generate a new request (this clears any current listeners)
      xhrDataRequest = new XMLHttpRequest();

      // Create our new Promise
      requestPromise = newRequestPromise(xhrDataRequest);

      // Assemble the request URL
      url = `${enrolmentConfiguration.axcelerateCourseInstanceDetailsEndpoint}?instanceid=${instanceId}&cors_key=${enrolmentConfiguration.corsKey}`;

      // Set up our request
      xhrDataRequest.open("GET", url);

      // Make the request
      xhrDataRequest.send();

      return requestPromise;
    }

    /**
     * Contact Matrix to tentatively enrol the current user
     * in an instance of a course.
     *
     * @param {String} instanceId The ID of the course instance to enrol the user in
     * @param {String} contactId The encrypted ID of the user to enrol in the course
     *
     * @returns Promise
     */
    function getAxcelerateTentativeCourseEnrolment(instanceId, contactId) {
      let url = "";
      let requestPromise = null;

      // Abort any current request
      xhrDataRequest.abort();

      // Generate a new request (this clears any current listeners)
      xhrDataRequest = new XMLHttpRequest();

      // Create our new Promise
      requestPromise = newRequestPromise(xhrDataRequest);

      // Assemble the request URL
      url = `${enrolmentConfiguration.axcelerateTentativeEnrolmentEndpoint}?instanceid=${instanceId}&contactid=${contactId}&cors_key=${enrolmentConfiguration.corsKey}`;

      // Set up our request
      xhrDataRequest.open("GET", url);

      // Make the request
      xhrDataRequest.send();

      return requestPromise;
    }

    /**
     * Contact Matrix to apply the a user's payment to their course enrollment
     *
     * @param {Number} amount The cost of the course enrolment
     * @param {String} invoiceId The ID of the payment invoice from the tentative enrolment
     * @param {String} contactId The encrypted ID of the user to enrol in the course
     *
     * @returns Promise
     */
    function getAxcelerateApplyCoursePayment(amount, invoiceId, contactId) {
      let url = "";
      let requestPromise = null;

      // Abort any current request
      xhrDataRequest.abort();

      // Generate a new request (this clears any current listeners)
      xhrDataRequest = new XMLHttpRequest();

      // Create our new Promise
      requestPromise = newRequestPromise(xhrDataRequest);

      // Assemble the request URL
      url = `${enrolmentConfiguration.axcelerateApplyCoursePaymentEndpoint}?amount=${amount}&invoiceid=${invoiceId}&contactid=${contactId}&cors_key=${enrolmentConfiguration.corsKey}`;

      // Set up our request
      xhrDataRequest.open("GET", url);

      // Make the request
      xhrDataRequest.send();

      return requestPromise;
    }

    /**
     * Contact Matrix to confirm the user enrolment in a
     * specific instance of a course
     *
     * @param {String} instanceId The ID of the course instance to check
     * @param {String} invoiceId The ID of the payment invoice from the tentative enrolment
     * @param {String} contactId The encrypted ID of the user to check for
     *
     * @returns Promise
     */
    function getAxcelerateConfirmCourseEnrolment(instanceId, invoiceId, contactId) {
      let url = "";
      let requestPromise = null;

      // Abort any current request
      xhrDataRequest.abort();

      // Generate a new request (this clears any current listeners)
      xhrDataRequest = new XMLHttpRequest();

      // Create our new Promise
      requestPromise = newRequestPromise(xhrDataRequest);

      // Assemble the request URL
      url = `${enrolmentConfiguration.axcelerateConfirmUserEnrolmentEndpoint}?instanceid=${instanceId}&contactid=${contactId}&invoiceid=${invoiceId}&cors_key=${enrolmentConfiguration.corsKey}`;

      // Set up our request
      xhrDataRequest.open("GET", url);

      // Make the request
      xhrDataRequest.send();

      return requestPromise;
    }

    /**
     * Show or hide the loading message as feedback for the user
     *
     * @param {Boolean} show Whether or not the message should be visible
     *
     * @returns void
     */
    function toggleLoadingMessage(show) {
      if (show) {
        loadingMessage.classList.add('is-active');
      } else {
        loadingMessage.classList.remove('is-active');
      }
    }

    /**
     * Given an Object of user details, extract the
     * address fields and format them into a single
     * line of text.
     *
     * @param {Object} userDetails The user's details (e.g. local storage data)
     *
     * @returns String
     */
    function generateFriendlyAddress(userDetails) {
      let addressText = '';

      if ( !valueIsFalsy( userDetails.q22330_q2 ) ) {
        // Address line #1
        addressText += `${userDetails.q22330_q2}`;
      }

      if ( !valueIsFalsy( userDetails.q22330_q4 ) ) {
        // City
        addressText += `, ${userDetails.q22330_q4} `;
      }

      if ( !valueIsFalsy( userDetails.q22330_q5 ) ) {
        // State
        addressText += userDetails.q22330_q5;
      }

      return addressText;
    }

    /**
     * Respond to clicks on the sign out link
     *
     * @returns void
     */
    function onSignOutClick() {
      // Clear the local storage data
      localStorage.removeItem('userContactId');
      localStorage.removeItem('userDetails');
      localStorage.removeItem('userStatus');
      localStorage.removeItem('userButton');
      localStorage.removeItem('userContactExpiry');
    }

    /**
     * Populate and submit the hidden error reporting form on the page
     *
     * @param {String} errorMessage An additional message for specfic error tracking
     *
     * @returns void
     */
    function submitErrorForm(errorMessage) {
      const userDetailsLocal = JSON.parse( localStorage.getItem('userDetails') );
      const courseDetailsLocal = JSON.parse( localStorage.getItem('courseDetails') );
      const userInvoiceLocal = localStorage.getItem('userInvoiceId');
      const errorForm = document.getElementsByClassName('js-ajax-error-form')[0];
      const errorFormInputs = errorForm.querySelectorAll('input');
      let errorDetails = '';

      // Initialise the AJAX loader for the error form
      const errorAjaxFormConfig = {
        formElement: errorForm
      };

      // eslint-disable-next-line no-undef
      squiz.fn.initFormSubmissionHandler(errorAjaxFormConfig);

      // Construc the error message
      errorDetails = `Course ID: ${courseDetailsLocal.courseId}. Instance ID: ${courseDetailsLocal.courseInstanceId}. Invoice ID: ${userInvoiceLocal}. ${errorMessage}`;

      // Insert the local data into the form
      for (let item of errorFormInputs) {
        switch ( item.getAttribute('id') ) {
          case 'q25084_q1':
            // Given Name
            item.value = userDetailsLocal.q22332_q1;
            break;

          case 'q25084_q2':
            // Family Name
            item.value = userDetailsLocal.q22332_q2;
            break;

          case 'q25084_q3':
            // Email
            item.value = userDetailsLocal.q22332_q5;
            break;

          case 'q25084_q4':
            // Contact Phone
            item.value = userDetailsLocal.q22332_q6;
            break;

          case 'q25084_q5':
            // Reported error
            item.value = errorDetails;
            break;

          default:
            break;
        }
      }

      // Automatically submit the access code form
      errorForm.querySelector('input[type=submit]').click();
    }

    /**
     * Show a specific step in the enrolment form.
     *
     * @param {Integer} stepNumber The step to display
     *
     * @returns void
     */
    function displayStep(stepNumber) {
      const stepIndex = stepNumber - 1;
      const enrolmentTabs = document.getElementsByClassName('wenrolment__tab');
      const enrolmentContent = document.getElementsByClassName('wenrolment__tab-content');

      // We assume there is the same number of tab buttons and content
      for (let i = 0, j = enrolmentTabs.length; i < j; ++i) {
        enrolmentTabs[i].classList.remove('wenrolment__tab--completed');
        enrolmentTabs[i].classList.remove('wenrolment__tab--active');
        enrolmentContent[i].classList.remove('wenrolment__tab-content--active');

        if (i < stepIndex) {
           enrolmentTabs[i].classList.add('wenrolment__tab--completed');
        }

        if (i === stepIndex) {
          enrolmentTabs[i].classList.add('wenrolment__tab--active');
          enrolmentContent[i].classList.add('wenrolment__tab-content--active');
        }
      }

      if (stepNumber === 2) {
        initStepTwo();
      }

      if (stepNumber === 3) {
        initStepThree();
      }

      if (stepNumber === 4) {
        initStepFour();
      }
    }
  }

  /**
   * Address lookup functionality
   *
   * Configuration with examples:
   *
   * @usage configuration = {
      googlePlacesApiEndpoint: "https://www.endeavourenergy.com.au/designs/connectors/google/google-places-api",
      googlePlaceDetailsApiEndpoint: "https://www.endeavourenergy.com.au/designs/connectors/google/google-place-details-api",
      googleGeocodingApiEndpoint: "https://www.endeavourenergy.com.au/designs/connectors/google/google-geocoding-api"
    };
   *
   */
  function initAddressLookup(configuration) {
    // We use this to make our asynchronous requests for data
    let xhrDataRequest = new XMLHttpRequest();

    // Capture the DOM elements and add the listeners for the address lookup component
    let locationInputField = document.getElementsByClassName('js-form-address-input')[0];
    let locationSuggestionsDropdown = document.getElementsByClassName('js-address-search-suggestions')[0];

    locationInputField.addEventListener('input', onLocationInputChange);

    /**
     * Respond to input on the location field
     *
     * @param {Change Event} evt Input Event that triggered the change
     */
    function onLocationInputChange(evt) {
      const { value } = evt.target;

      // Clear any user location that has been captured already
      setLocation({
        "addressLineOne": "",
        "addressLineTwo": "",
        "suburb": "",
        "postcode": "",
        "state": ""
      });

      // Reset the error styling
      setInputErrorToggle(false);

      if (value.length >= 3) {
        // Trigger the location suggestions dropdown
        getLocationSuggestions(value)
        .then( (data) => {
          // Check for any returned errors
          if (data.status === "OK") {
            // Address data was returned, update the input dropdown
            setLocationSuggestions(data.predictions.map( (prediction) => {
              return {
                "address": prediction.description,
                "place_id": prediction.place_id
              }
            }));
          } else {
            if (data.status === "ZERO_RESULTS") {
              setLocationSuggestions([{
                "address": "No locations found for that address",
                "place_id": ""
              }]);
              // Show the error styling
              setInputErrorToggle(true);
            } else {
              // Likely a general error has occurred.
              setAlertMessage(`There has been a problem retrieving location data. The API returned an error message. Error: ${data.status}`);
            }
          }
        })
        .catch( (errorObject) => {
          if (errorObject.eventType === 'error') {
            setAlertMessage(`There has been a problem retrieving location data. Status code: ${errorObject.response.status}`);
          }
        });
      } else {
        // Remove the suggestions
        setLocationSuggestions([]);
      }
    }

    /**
     * Respond to clicks on the address location suggestions
     *
     * @param {Click Event} evt Event that triggered the selection
     */
    function onAddressSuggestionClick(evt) {
      evt.preventDefault();

      let placeID = evt.target.getAttribute('data-placeid');

      // Update the form fields with the selected suggestion
      setLocation({
        "fullAddress": evt.target.value
      });

      // Remove the suggestions
      setLocationSuggestions([]);

      // Make the request to get the address info (specifically, the postcode and locality)
      getPlaceData(placeID)
        .then( (data) => {
          // Capture the additional address data needed
          let addressLineOne = "";
          let addressLineTwo = "";
          let postcode = "";
          let suburb = "";
          let state = "";
          let latitude = "";
          let longitude = "";
          let latLong = "";

          // Check for any returned errors
          if (data.status === "OK") {
            // Location data was returned, capture the data we need
            for (var i = 0, j = data.result.address_components.length; i < j; ++i) {
              if (data.result.address_components[i].types[0] === 'subpremise') {
                addressLineOne += `${data.result.address_components[i].short_name}/`;
              }

              if (data.result.address_components[i].types[0] === 'street_number') {
                addressLineOne += data.result.address_components[i].short_name;
              }

              if (data.result.address_components[i].types[0] === 'route') {
                addressLineTwo = data.result.address_components[i].short_name;
              }

              if (data.result.address_components[i].types[0] === 'postal_code') {
                postcode = data.result.address_components[i].short_name;
              }

              if (data.result.address_components[i].types[0] === 'locality') {
                suburb = data.result.address_components[i].short_name;
              }

              if (data.result.address_components[i].types[0] === 'administrative_area_level_1') {
                state = data.result.address_components[i].short_name;
              }
            }

            // Capture the lat/lng
            latitude = data.result.geometry.location.lat.toString();
            longitude = data.result.geometry.location.lng.toString();
            latLong = `${latitude},${longitude}`;

            // We don't always get the data we need back from this API (e.g. businesses, centres).
            // Try a different endpoint using the lat/lng from the previous response.
            if (postcode === "" || suburb === "") {
              // Make the request to get locations for the lat/lng
              getLatLongData(latLong)
                .then( (data) => {
                  let addressLineOne = "";
                  let addressLineTwo = "";
                  let postcode = "";
                  let suburb = "";
                  let state = "";

                  // Take the first suggestion and update the state with the address
                  if (data.results.length > 0) {
                    // Try to find the address postcode and suburb
                    for (var i = 0, j = data.results[0].address_components.length; i < j; ++i) {
                      if (data.results[0].address_components[i].types[0] === 'subpremise') {
                        addressLineOne += `${data.results[0].address_components[i].short_name}/`;
                      }

                      if (data.results[0].address_components[i].types[0] === 'street_number') {
                        addressLineOne += data.results[0].address_components[i].short_name;
                      }

                      if (data.results[0].address_components[i].types[0] === 'route') {
                        addressLineTwo = data.results[0].address_components[i].short_name;
                      }

                      if (data.results[0].address_components[i].types[0] === 'postal_code') {
                        postcode = data.results[0].address_components[i].short_name;
                      }

                      if (data.results[0].address_components[i].types[0] === 'locality') {
                        suburb = data.results[0].address_components[i].short_name;
                      }

                      if (data.results[0].address_components[i].types[0] === 'administrative_area_level_1') {
                        state = data.results[0].address_components[i].short_name;
                      }
                    }

                    // Update the form fields with the first suggestion
                    setLocation({
                      "addressLineOne": addressLineOne,
                      "addressLineTwo": addressLineTwo,
                      "postcode": postcode,
                      "suburb": suburb,
                      "state": state
                    });
                  }

                  if (postcode.length === 0) {
                    // We need the postcode, so alert the user if we couldn't get that data
                    setAlertMessage("We were unable to determine your postcode, please try searching for a different address.");
                  }
                })
                .catch( (errorObject) => {
                  if (errorObject.eventType === 'error') {
                    setAlertMessage(`There has been a problem retrieving your address information. Status code: ${errorObject.response.status}`);
                  }
                });
            } else {
              // We got the data we needed from the Place Details API.
              // Update the form fields with the postcode and lat/long co-ords
              setLocation({
                "addressLineOne": addressLineOne,
                "addressLineTwo": addressLineTwo,
                "postcode": postcode,
                "suburb": suburb,
                "state": state
              });
            }
          } else {
            // Likely an error has occurred.
            setAlertMessage(`There has been a problem retrieving information about your selected address. The API returned an error message. Error: ${data.status}`);
          }
        })
        .catch( (errorObject) => {
          if (errorObject.eventType === 'error') {
            setAlertMessage(`There has been a problem retrieving information about your selected address. Status code: ${errorObject.response.status}`);
          }
        });
    }

    /**
     * Request some suggestions from the location API
     *
     * @param {String} input The address, or partial address, to lookup
     *
     * @returns Promise
     */
    function getLocationSuggestions(input) {
      let url = "";
      let sanitisedInput = "";
      let requestPromise = null;

      // Abort any current request
      xhrDataRequest.abort();

      // Generate a new request (this clears any current listeners)
      xhrDataRequest = new XMLHttpRequest();

      // Create our new Promise
      requestPromise = newRequestPromise(xhrDataRequest);

      // Clear up the address input
      sanitisedInput = encodeURIComponent(input).replace(/%20/g, '+');

      // Assemble the request URL
      url = `${configuration.googlePlacesApiEndpoint}?address=${sanitisedInput}&cors_key=${configuration.corsKey}`;

      // Set up our request
      xhrDataRequest.open("GET", url);

      // Make the request
      xhrDataRequest.send();

      return requestPromise;
    }

    /**
     * Request further information on the user-selected address
     *
     * @param {String} placeid The Google Places API Place ID value
     *
     * @returns Promise
     */
    function getPlaceData(placeid) {
      let url = "";
      let requestPromise = null;

      // Abort any current request
      xhrDataRequest.abort();

      // Generate a new request (this clears any current listeners)
      xhrDataRequest = new XMLHttpRequest();

      // Create our new Promise
      requestPromise = newRequestPromise(xhrDataRequest);

      // Assemble the request URL
      url = `${configuration.googlePlaceDetailsApiEndpoint}?placeid=${placeid}&cors_key=${configuration.corsKey}`;

      // Set up our request
      xhrDataRequest.open("GET", url);

      // Make the request
      xhrDataRequest.send();

      return requestPromise;
    }

    /**
     * Request possible address locations from provided latitude and longitude co-ordinates
     *
     * @param {String} latLong The latitude and longitude co-ordinates to lookup. e.g. "-33.8666677,151.2021696"
     *
     * @returns Promise
     */
    function getLatLongData(latLong) {
      let url = "";
      let requestPromise = null;

      // Abort any current request
      xhrDataRequest.abort();

      // Generate a new request (this clears any current listeners)
      xhrDataRequest = new XMLHttpRequest();

      // Create our new Promise
      requestPromise = newRequestPromise(xhrDataRequest);

      // Assemble the request URL
      url = `${configuration.googleGeocodingApiEndpoint}?latlng=${latLong}&cors_key=${configuration.corsKey}`;

      // Set up our request
      xhrDataRequest.open("GET", url);

      // Make the request
      xhrDataRequest.send();

      return requestPromise;
    }

    /**
     * Update the individual location fields with location data
     * An Object should be provided for each of the values to be set.
     * If a value is not provided, then the corresponding field will not be updated.
     *
     * @param {Object} An Object of key/value pairs
     *
     * @returns void
     */
    function setLocation({ fullAddress = null, addressLineOne = null, addressLineTwo = null, suburb = null, state = null, postcode = null }) {
      const userDetailsLocal = JSON.parse( localStorage.getItem('userDetails') );
      let locationStreetAddressField = document.getElementById('q22330_q2');
      let locationSuburbField = document.getElementById('q22330_q4');
      let locationStateField = document.getElementById('q22330_q5');
      let locationPostcodeField = document.getElementById('q22330_q6');

      // Update the input field with the address
      if (fullAddress !== null) {
        locationInputField.value = fullAddress;
      }

      // Update the individual fields
      if (addressLineOne !== null) {
        locationStreetAddressField.value = addressLineOne;
      } else {
        locationStreetAddressField.value = '';
      }

      if (addressLineTwo !== null) {
        if ( !valueIsFalsy(addressLineOne) ) {
          locationStreetAddressField.value = `${locationStreetAddressField.value} ${addressLineTwo}`;
        } else {
          locationStreetAddressField.value = addressLineTwo;
        }
      }

      if (suburb !== null) {
        locationSuburbField.value = suburb;
      } else {
        locationSuburbField.value = '';
      }

      if (state !== null) {
        locationStateField.value = state;
      } else {
        locationStateField.value = '';
      }

      if (postcode !== null) {
        locationPostcodeField.value = postcode;
      } else {
        locationPostcodeField.value = '';
      }
    }

    /**
     * Update the address location suggestions dropdown
     *
     * @param {Array} suggestionArray Array of options to use as the suggestions.
     * Each item in the Array should be an Object of the format:
     * {
        "address": "Full address",
        "place_id": "Google Place ID"
     * }
     *
     * @returns void
     */
    function setLocationSuggestions(suggestionArray) {
      const suggestionMarkupArray = [];
      let suggestionButtons = [];

      // Show or hide the suggestions
      if (suggestionArray.length !== 0) {
        locationInputField.classList.add('is-active');
      } else {
        locationInputField.classList.remove('is-active');
      }

      // Generate and update the dropdown options
      for (var i = 0, j = suggestionArray.length; i < j; ++i) {
        suggestionMarkupArray.push(`
          <li class="wenrolment__suggestions__list-item">
            <button class="js-address-suggestion wenrolment__suggestions__button" value="${suggestionArray[i].address}" data-placeid="${suggestionArray[i].place_id}">${suggestionArray[i].address}</button>
          </li>
        `);
      }

      locationSuggestionsDropdown.innerHTML = suggestionMarkupArray.join('');

      // Add listeners to the new buttons
      if (suggestionArray.length !== 0) {
        suggestionButtons = locationSuggestionsDropdown.getElementsByClassName('js-address-suggestion');

        for (var b = 0, w = suggestionButtons.length; b < w; ++b) {
          suggestionButtons[b].addEventListener('click', onAddressSuggestionClick);
        }
      }
    }

    /**
     * Show/hide the address search error styling
     *
     * @returns void
     */
    function setInputErrorToggle(showError) {
      if (showError) {
          locationInputField.classList.add('has-error');
      } else {
          locationInputField.classList.remove('has-error');
      }
    }
  }

  /**
   * Check if a given value is falsy
   *
   * @param {class} val The value to check
   *
   * @returns Boolean
   */
  function valueIsFalsy(val) {
    if (val === undefined || val === false || val === '' || val === null) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Display either the alert (information) or error (critical issue)
   * popup with a message as feedback for the user
   *
   * @param {String} msg The general message to display
   * @param {String} details An additional message with specific information
   * @param {Boolean} isCritical Whether the error should block further interactions
   *
   * @returns void
   */
  function setAlertMessage(msg, details, isCritical) {
    const alertMessagePopup = document.getElementsByClassName('js-enrolment-popup')[0];
    const alertMessage = document.getElementsByClassName('js-enrolment-message')[0];
    const alertDetails = document.getElementsByClassName('js-enrolment-details')[0];
    const errorMessagePopup = document.getElementsByClassName('js-error-popup')[0];
    const errorMessage = document.getElementsByClassName('js-error-message')[0];
    const errorDetails = document.getElementsByClassName('js-error-details')[0];

    if (isCritical) {
      // Set the alert content
      errorMessage.textContent = msg;

      if (details !== '') {
        errorDetails.textContent = details;
      }

      // Show the alert popup
      errorMessagePopup.classList.add('is-active');
    } else {
      // Set the alert content
      alertMessage.textContent = msg;

      if (details !== '') {
        alertDetails.textContent = details;
      }

      // Show the alert popup
      alertMessagePopup.classList.add('is-active');
    }
  }

  /**
   * Hide the alert popup
   *
   * @param {Click Event} evt Click Event on the button
   *
   * @returns void
   */
  function onAlertCloseClick(evt) {
    const alertMessagePopup = document.getElementsByClassName('js-enrolment-popup')[0];

    evt.preventDefault();

    // Hide the alert popup
    alertMessagePopup.classList.remove('is-active');
  }

  /**
   * Create a new Promise that we can use to response to asynchronus XML Http Requests
   *
   * @param {XMLHttpRequest} xhrRequest The XMLHttpRequest to attach the event listeners to
   * @param {String} responseType The expected content type of the response. Default: JSON
   *
   * @returns Promise
   */
  function newRequestPromise(xhrRequest, responseType) {
    return new Promise( (resolve, reject) => {
      // Respond to requests to GET the data
      xhrRequest.addEventListener('load', function(evt) {
        if (evt.currentTarget.status === 200) {
          // We got a good response
          if (responseType === 'html') {
            resolve(evt.currentTarget.response);
          } else {
            resolve(JSON.parse(evt.currentTarget.response));
          }
        } else {
          // We got a bad response (e.g. 403, 404)
          reject( {
            "response": evt.currentTarget,
            "eventType": 'error'
            }
          );
        }
      });

      // Respond to request errors
      xhrRequest.addEventListener('error', function(evt) {
        reject( {
          "response": evt.currentTarget,
          "eventType": 'error'
          }
        );
      });

      // Respond to request aborts
      xhrRequest.addEventListener('abort', function(evt) {
        reject( {
          "response": evt.currentTarget,
          "eventType": 'abort'
          }
        );
      });
    });
  }

  // eslint-disable-next-line no-undef
  const enrolmentConfiguration = (typeof enrolmentConfig !== 'undefined') ? enrolmentConfig : null;

  // Initialise the enrolment process
  if (enrolmentConfiguration !== null) {
    initWorkshopEnrolment(enrolmentConfiguration);
  }
}());